import type { LabelHTMLAttributes } from 'react';
import clsx from 'clsx';

import styles from './styles/Label.module.scss';

export type LabelProps = {
  mobileText?: string;
  size?: 's' | 'm' | 'l';
};

const Label = ({
  children,
  className,
  mobileText,
  size = 'm',
  ...props
}: LabelProps & LabelHTMLAttributes<HTMLLabelElement>) => {
  return (
    <label
      className={clsx(styles.label, styles[`size-${size}`], { [styles.hasMobileText]: !!mobileText }, className)}
      data-cxy-name="label"
      {...props}
    >
      <>
        {mobileText ? (
          <>
            <span data-testid="mobile-label">{mobileText}</span>
            <span data-testid="label">{children}</span>
          </>
        ) : (
          children
        )}
      </>
    </label>
  );
};

export { Label };
